// 特权详情落地页
export const PRIVILEGE_URL = 'https://kdocs.cn/l/crVCOkGGJUAi';
